import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, HelpCircle, MessageCircle, Book } from 'lucide-react';
import YegoLogo from './YegoLogo';

const Footer = () => {
  const siteName = 'YEGO';
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="mt-auto border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
        {/* Grid: 4 columns on desktop, 2 on tablet, stacked on mobile */}
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          
          {/* About YEGO - Full width on mobile */}
          <div className="col-span-2 lg:col-span-1 mb-2 sm:mb-0">
            <div className="flex items-center gap-2 mb-2 sm:mb-4">
              <YegoLogo size={32} />
              <span className="text-base sm:text-lg font-bold text-gray-900 dark:text-white">
                {siteName}
              </span>
            </div>
            <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-2 sm:mb-4">
              Capturing the pulse of the culture by delivering timely, accurate, and high-energy news.
            </p>
            <a 
              href="mailto:support@yegonews.com" 
              className="inline-flex items-center gap-1.5 text-xs sm:text-sm text-emerald-600 hover:text-emerald-700 transition-colors"
            >
              <Mail className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
              support@yegonews.com
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xs sm:text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-2 sm:mb-4">
              Quick Links
            </h3>
            <ul className="space-y-1.5 sm:space-y-3">
              <li>
                <Link 
                  to="/about" 
                  className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 hover:text-emerald-600 dark:hover:text-emerald-500 transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 hover:text-emerald-600 dark:hover:text-emerald-500 transition-colors"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link 
                  to="/" 
                  className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 hover:text-emerald-600 dark:hover:text-emerald-500 transition-colors"
                >
                  Home
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-xs sm:text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-2 sm:mb-4">
              Legal
            </h3>
            <ul className="space-y-1.5 sm:space-y-3">
              <li>
                <Link 
                  to="/privacy" 
                  className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 hover:text-emerald-600 dark:hover:text-emerald-500 transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms" 
                  className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 hover:text-emerald-600 dark:hover:text-emerald-500 transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link 
                  to="/disclaimer" 
                  className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 hover:text-emerald-600 dark:hover:text-emerald-500 transition-colors"
                >
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div>

          {/* Help & Support */}
          <div>
            <h3 className="text-xs sm:text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-2 sm:mb-4">
              Help & Support
            </h3>
            <ul className="space-y-1.5 sm:space-y-3">
              <li>
                <Link 
                  to="/help" 
                  className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 hover:text-emerald-600 dark:hover:text-emerald-500 transition-colors inline-flex items-center gap-1.5"
                >
                  <HelpCircle className="h-3 w-3" />
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200 dark:border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4">
          <p className="text-[10px] sm:text-xs text-gray-500 dark:text-gray-500 text-center">
            © {currentYear} {siteName}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
